module.exports = __webpack_public_path__ + "static/media/why-work-in-technical-support.7a8a3f21.md";